/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolAnchorIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-anchor"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12 22.32Q12 22.32 11.2 22.32Q10.4 22.32 8.74 21.75Q7.08 21.18 5.72 20.18Q4.38 19.18 3.52 17.84Q2.67 16.5 2.67 15L2.67 12.68Q2.67 12.25 3.04 12.07Q3.4 11.9 3.73 12.15L6.28 14.05Q6.78 14.4 6.8 15.01Q6.83 15.63 6.4 16.05L5.85 16.6Q6.55 17.68 7.89 18.48Q9.22 19.27 10.68 19.55L10.68 11.32L9 11.32Q8.45 11.32 8.06 10.94Q7.67 10.55 7.67 10Q7.67 9.45 8.06 9.06Q8.45 8.68 9 8.68L10.68 8.68L10.68 8.05Q9.8 7.65 9.24 6.84Q8.68 6.03 8.68 5Q8.68 3.63 9.65 2.65Q10.63 1.68 12 1.68Q13.38 1.68 14.35 2.65Q15.32 3.63 15.32 5Q15.32 6.03 14.76 6.84Q14.2 7.65 13.32 8.05L13.32 8.68L15 8.68Q15.55 8.68 15.94 9.06Q16.32 9.45 16.32 10Q16.32 10.55 15.94 10.94Q15.55 11.32 15 11.32L13.32 11.32L13.32 19.55Q14.78 19.27 16.11 18.48Q17.45 17.68 18.15 16.6L17.6 16.05Q17.18 15.63 17.2 15.01Q17.23 14.4 17.73 14.05L20.27 12.15Q20.6 11.9 20.96 12.07Q21.32 12.25 21.32 12.68L21.32 15Q21.32 16.5 20.48 17.84Q19.63 19.18 18.27 20.18Q16.93 21.18 15.26 21.75Q13.6 22.32 12 22.32ZM12 5.67Q12.28 5.67 12.47 5.47Q12.68 5.28 12.68 5Q12.68 4.72 12.47 4.53Q12.28 4.33 12 4.33Q11.72 4.33 11.53 4.53Q11.32 4.72 11.32 5Q11.32 5.28 11.53 5.47Q11.72 5.67 12 5.67Z" fill={color} />
    </svg>
  );
}
